export class AuthConfig {
	authUserNameUrl: string;
	authUrl: string;
	refreshTokenUrl: string;
	loginRoute: string;
	restoreRoute: string;
	checkUser: string;
	restoreUrl: string;
}
